// extracted by mini-css-extract-plugin
export var container = "topRichText-module--container--A5awt";
export var icon = "topRichText-module--icon--nojn4";
export var show = "topRichText-module--show--J-ctu";
export var text = "topRichText-module--text--I633Z";